<div class="lock-account-dialog">
    <h3>🔒 Verrouillage du compte</h3>

    <p>
    Vous êtes sur le point de verrouiller ce compte utilisateur.
    </p>

    <p>
    <strong>Confirmez-vous cette opération ?</strong>
    </p>

    <div class="actions">
    <button mat-stroked-button (click)="cancel()">
        Annuler
    </button>

    <button mat-raised-button color="primary" (click)="confirm()">
        Verrouiller
    </button>
    </div>
</div>